module.exports = __webpack_public_path__ + "img/help-icon.cdef30a4.svg";